import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-slate-100">
      <motion.div initial={{ scale: 0.85, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="w-full max-w-sm rounded-3xl bg-white shadow-xl p-8 text-center">
        <XCircle className="w-16 h-16 text-slate-400 mx-auto mb-4" />
        <h2 className="font-display text-2xl font-bold text-slate-800 mb-1">Checkout canceled</h2>
        <p className="text-slate-500 font-medium mb-5">No worries — you can subscribe anytime from the parent portal.</p>
        <button data-testid="cancel-back-btn" onClick={() => navigate("/parent")} className="pop-btn w-full rounded-xl bg-indigo-500 text-white font-bold py-3">Back to Portal</button>
      </motion.div>
    </div>
  );
}
